














import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component({
    model: {
        prop: 'properties',
        event: 'change'
    },
    components:{
        VEditor: require('vue2-ace-editor')
    },
})
export default class BHFlowFieldGenerator extends Vue {
    @Prop({ default() { return []; } })
    data!: any[];

    @Prop({ default() { return {}; } })
    properties: any;

    @Prop({ default: false })
    child!: boolean;

    @Prop({ default() { return []; } })
    subItems: any;

    public getItems(lists: any[]) {
        return lists.map(i => i.label);
    }

    public getFields(target: string, lists: any[]) {
        return lists.filter(i => i.label === target)[0].fields;
    }

    public initEditor(editor: any) {
        require('brace/ext/language_tools');
        require('brace/mode/javascript');
        require('brace/theme/chrome');
        require('brace/snippets/javascript');
    }

    public generateLabel(label: string, index: number) {
        return label.replace(/\$id/g, `${index + 1}`);
    }
}
